const status = [
    { value: 'active', label: { en: 'Active', es: 'Activo' } },
    { value: 'paused', label: { en: 'Paused', es: 'Pausado' } },
];

export default status;